import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from 'src/components/Octopath/layout';
import 'src/styles/table.scss';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const Battle = makeShortcode("Battle");
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout>{children}</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Agnea Single Story" mdxType="SEO" />
    <h2 {...{
      "id": "route"
    }}>{`Route`}</h2>
    <p>{`Start Agnea`}<br parentName="p"></br>{`
`}{`Take middle bridge on the way home, Entreat `}<strong parentName="p">{`Bottle of Poison Dust & Shadow S`}</strong>{`.`}</p>
    <p>{`Go to Festival Grounds. Allure NPC outside NPC Festival Grounds`}<br parentName="p"></br>{`
`}{`TP Cropdale, Allure quest NPC.`}<br parentName="p"></br>{`
`}{`Go to Weapon Shop`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`Bronze Dagger (Equip)`}</li>
      </ul>
      <h5 {...{
        "id": "sell"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Fruit Knife`}</li>
        <li parentName="ul">{`Bottle of Poison Dust`}</li>
        <li parentName="ul">{`1 Inspirating Plum`}</li>
      </ul>
    </Menu>
    <p>{`Go back to Festival Grounds.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Wind S`}</strong>{`.`}</p>
    <p>{`Break/Flee from battles. If Agnea < 160HP, heal her.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "duorduor-3600hp-5s-daggeraxewind"
      }}>{`Duorduor 3600HP 5S (Dagger,Axe,Wind)`}</h4>
      <h5 {...{
        "id": "turn-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: Attack`}</li>
        <li parentName="ul">{`Gus: Chop Wood`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: Lion Dance`}</li>
        <li parentName="ul">{`Gus: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Gus: Chop Wood`}</li>
        <li parentName="ul">{`Agnea: Ruinous Kick x4`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: Grape if needed (If Gus got hit twice, target Agnea manually)`}</li>
        <li parentName="ul">{`Gus: Chop Wood x4`}</li>
      </ul>
      <h5 {...{
        "id": "turn-5"
      }}>{`Turn 5`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: Plum Gus`}</li>
        <li parentName="ul">{`Gus: Chop Wood`}</li>
      </ul>
      <h5 {...{
        "id": "turn-6"
      }}>{`Turn 6`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: Attack`}</li>
        <li parentName="ul">{`Gus: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-7"
      }}>{`Turn 7`}</h5>
      <ul>
        <li parentName="ul">{`Gus: Chop Wood`}</li>
        <li parentName="ul">{`Agnea: Lion Dance`}</li>
      </ul>
      <h5 {...{
        "id": "turn-8"
      }}>{`Turn 8`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: Ruinous Kick x4`}</li>
        <li parentName="ul">{`Gus: Shadow S`}</li>
      </ul>
      <h5 {...{
        "id": "turn-9"
      }}>{`Turn 9`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: Wind S`}</li>
        <li parentName="ul">{`Gus: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-10"
      }}>{`Turn 10`}</h5>
      <ul>
        <li parentName="ul">{`Gus: Attack x4`}</li>
        <li parentName="ul">{`Agnea: Lion Dance`}</li>
      </ul>
      <h5 {...{
        "id": "turn-11"
      }}>{`Turn 11`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: Ruinous Kick x4`}</li>
        <li parentName="ul">{`Gus: Chop Wood x3`}</li>
      </ul>
    </Battle>
    <p>{`Entreat `}<strong parentName="p">{`Mama's Dress`}</strong>{`, finish Chapter.`}</p>
    <h3 {...{
      "id": "exploration"
    }}>{`Exploration`}</h3>
    <p>{`Pick `}<strong parentName="p">{`$1600`}</strong>{`. Tag Crackridge Anchorage, go back, then warp to Anchorage and take boat to New Delsta.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you get Clerics in 1st 2 tries, you can buy 2 Fire M instead of 3 and skip the Herb. You then kill a minimum of 1 Borderfall/Montwise battle, and the 2nd you can run from or Thunder M. This is for money and assumes no Caits/Puffs.`}</p>
    </blockquote>
    <p>{`Go to Black Market, pick `}<strong parentName="p">{`Herb of Serenity`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sell-1"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Purse of Hope`}</li>
        <li parentName="ul">{`Herb of Serenity if you have it already.`}</li>
      </ul>
      <h5 {...{
        "id": "buy-1"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`1 Fire S`}</li>
        <li parentName="ul">{`1 Ice S`}</li>
        <li parentName="ul">{`1 Thunder S`}</li>
        <li parentName="ul">{`3 Fire M`}</li>
        <li parentName="ul">{`1 Ice M`}</li>
      </ul>
    </Menu>
    <p>{`Go get `}<strong parentName="p">{`Osvald`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`New Delsta Anchorage`}</strong>{`, go to `}<strong parentName="p">{`New Delsta`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you get a Cait or Puff, kill with Ice M.`}<br parentName="p"></br>{`
`}{`You then delay Tropu'hopu until after Assassins.`}<br parentName="p"></br>{`
`}{`Order is Throne, Partitio, New Delsta, Conning, New Delsta.`}</p>
    </blockquote>
    <h3 {...{
      "id": "new-delsta"
    }}>{`New Delsta`}</h3>
    <p>{`Start Agnea Ch.2`}<br parentName="p"></br>{`
`}{`Get Throne, Ice S + 1 Agnea atk or 2 Osvald atks`}</p>
    <p>{`Steal `}<strong parentName="p">{`Ice S, Wind S, Light S`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Entreat `}<strong parentName="p">{`Red Apple`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`Weapon Shop`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-2"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`1 Unerring Earring`}</li>
      </ul>
      <h5 {...{
        "id": "sell-2"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Herb of Serenity if not done earlier`}</li>
      </ul>
    </Menu>
    <p>{`Trigger quest. `}</p>
    <p>{`TP `}<strong parentName="p">{`New Delsta: Anchorage`}</strong>{`. Take boat to `}<strong parentName="p">{`Beasting Bay: Anchorage`}</strong>{`.`}</p>
    <h3 {...{
      "id": "beasting-bay-anchorage"
    }}>{`Beasting Bay: Anchorage`}</h3>
    <p>{`Kill up to 2 encounters using Wind S and Light S:`}</p>
    <ul>
      <li parentName="ul">{`Long ear lloris + 2 lloris: Break long ear with Throne Dagger x2 then S stone + Ruinous Kick x2`}</li>
      <li parentName="ul">{`Frog II + Fly: Break Frog II with Agnea Dagger x2, Break Fly with Throne Sword x2, then S stone + Fireball x2`}</li>
      <li parentName="ul">{`Slug + Fly: Staff x2 Slug, Sword x2 Fly, S stone + Ruinous Kick Fly`}</li>
      <li parentName="ul">{`2 Frog II: Break both then Light S`}</li>
      <li parentName="ul">{`Frog II + 2 Frog I: Break Frog II with Dagger x2 then Light S`}</li>
      <li parentName="ul">{`Slug + 2 Frog I: Sword x2 or Staff x2 Slug, S stone`}</li>
    </ul>
    <p>{`1st 3 battles give enough JP, 4th only if 1T, 5&6 need an extra battle.`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you get a Cait/Puff on the first screen, kill with Fire M.`}</p>
    </blockquote>
    <h3 {...{
      "id": "west-tropuhopu-traverse"
    }}>{`West Tropu'hopu Traverse`}</h3>
    <p>{`Kill battle with `}<strong parentName="p">{`Ice M`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "learn-skills"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: +Lightning Bolt +Analyze`}</li>
        <li parentName="ul">{`Throne: +Armor Corrosive`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: +`}{`[1]`}{`Evasive Maneuvers`}</li>
      </ul>
    </Menu>
    <p>{`Tag `}<strong parentName="p">{`Tropu'hopu`}</strong>{`. TP `}<strong parentName="p">{`Cropdale`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`You can do this in either order. Cropdale has the advantage of letting you see if you got a Cait/Puff. I like the WM warp movement more with New Delsta more.`}</p>
    </blockquote>
    <h3 {...{
      "id": "cropdale"
    }}>{`Cropdale`}</h3>
    <p>{`Go to `}<strong parentName="p">{`Oresrush`}</strong>{`, get `}<strong parentName="p">{`Partitio`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`New Delsta`}</strong>{`.`}</p>
    <h3 {...{
      "id": "new-delsta-1"
    }}>{`New Delsta`}</h3>
    <p>{`Entreat `}<strong parentName="p">{`Fire M`}</strong>{`. Entreat `}<strong parentName="p">{`Ticket`}</strong>{`. Entreat `}<strong parentName="p">{`Rare Cog`}</strong>{`.`}</p>
    <p>{`Steal `}<strong parentName="p">{`Antique Coin`}</strong>{`. Steal `}<strong parentName="p">{`Herb of Clarity & Gold Ring`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Herb of Clarity is for Fire M position in menu, if you got a random drop that takes a slot skip it.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`Can skip Steals based on what Caits/Puffs you got.`}</p>
    </blockquote>
    <p>{`Do right Allure on 2nd screen and turn it in.`}</p>
    <p>{`TP `}<strong parentName="p">{`Beasting Bay: Anchorage`}</strong>{`, take boat to `}<strong parentName="p">{`Canalbrine`}</strong>{`.`}</p>
    <h3 {...{
      "id": "canalbrine"
    }}>{`Canalbrine`}</h3>
    <p>{`Entreat `}<strong parentName="p">{`Pom M`}</strong>{` & Hire `}<strong parentName="p">{`Smooth Talker`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to Weapon Shop`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-3"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`Critical Earring`}</li>
      </ul>
      <h5 {...{
        "id": "sell-3"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Gold Items`}</li>
      </ul>
    </Menu>
    <p>{`Go to Conning Creek.`}</p>
    <p>{`Kill both Conning Creek battles during day with Fire M.`}</p>
    <h3 {...{
      "id": "conning-creek"
    }}>{`Conning Creek`}</h3>
    <p>{`Steal `}<strong parentName="p">{`Wind L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Rainbow Glass Bottle`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`New Delsta`}</strong>{`.`}</p>
    <h3 {...{
      "id": "new-delsta-2"
    }}>{`New Delsta`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "learn-skills-1"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: +Collect +Hired Help (If enough JP)`}</li>
      </ul>
    </Menu>
    <p>{`Finish Allures. Walk to La'mani, switch to night before fight.`}</p>
    <Battle mdxType="Battle">
      <blockquote>
        <p parentName="blockquote">{`There are lot's of variations you can do here. Listing safest.`}</p>
      </blockquote>
      <h4 {...{
        "id": "lamani-13000hp-4s-speardaggerfireiceshadow"
      }}>{`La'mani 13000HP 4S (Spear,Dagger,Fire,Ice,Shadow)`}</h4>
      <h5 {...{
        "id": "turn-1-1"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: Attack x2`}</li>
        <li parentName="ul">{`Osvald: Fireball x2`}</li>
        <li parentName="ul">{`Throne: Armor Corrosive`}</li>
        <li parentName="ul">{`Partitio: Spear`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-1"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: HHG x3`}</li>
      </ul>
    </Battle>
    <p>{`Go to Inventor, do Inventor stuff.`}<br parentName="p"></br>{`
`}{`Go towards Merry Hills.`}<br parentName="p"></br>{`
`}{`Kill Borderfall battle with Fire M, pick `}<strong parentName="p">{`Thunder M`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Kill Montwise battle with Fire M`}</p>
    <blockquote>
      <p parentName="blockquote">{`If you need to kill Montwise battle with Thunder M, either do Night + Ruinous Kick x2 + Thunder M, or day ASA break into Thunder M`}</p>
    </blockquote>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: +Stimulate or +BG`}</li>
        <li parentName="ul">{`Osvald: Inventor`}</li>
        <li parentName="ul">{`Partitio: +Collect if not learned yet / +Ember if possible`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-1"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: +`}{`[1]`}{`A Step Ahead`}</li>
        <li parentName="ul">{`Partitio: +`}{`[1]`}{`Grow on Trees +`}{`[2]`}{`A Step Ahead`}</li>
        <li parentName="ul">{`Throne: +`}{`[2]`}{`A Step Ahead`}</li>
        <li parentName="ul">{`Osvald: +`}{`[2]`}{`A Step Ahead`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "caits-and-puffs"
    }}>{`Caits and Puffs`}</h3>
    <p>{`With 1000 or less extra experience, it's optimal to still go for BG. Getting enough JP for Extra Experience before Assassins nets you 720 more EXP. To get this efficiently it takes a Queen Puff + a Cait, and possibly a bit more JP on top.`}</p>
    <h4 {...{
      "id": "1250-exp-cultured"
    }}>{`+1250 EXP (Cultured)`}</h4>
    <p>{`Take 2 Merry Hills battles, both day. Decent chance you will need Sai battles.`}</p>
    <h4 {...{
      "id": "1500-exp-cait--puff"
    }}>{`+1500 EXP (Cait + Puff)`}</h4>
    <p>{`Take 1 Merry Hills day, might need Sai battles.`}</p>
    <h4 {...{
      "id": "king-puff--chubby-cait"
    }}>{`King Puff & Chubby Cait`}</h4>
    <p>{`King Puff teaches Osvald Extra Experience.`}<br parentName="p"></br>{`
`}{`Both skip the money in the house. Chubby Cait sells Poetry of the Soul in Chapter 5.`}</p>
    <h3 {...{
      "id": "western-merry-hills-pass"
    }}>{`Western Merry Hills Pass`}</h3>
    <h3 {...{
      "id": "battle-clears"
    }}>{`Battle Clears`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Enemies`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Clear`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`EXP`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Anteater + 2 Ant`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Wind L + AC + HHG x4`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`426`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Anteater + Apeking`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`AC Anteater + Wind L + HHG x4`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`592`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`3 Apes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Wind L + HHG x4`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`318`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`2 Apes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Wind L + HHG x4`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`440`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Eagle + Monkey`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Wind L + HHG x4`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`450`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`2 Eagle`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Wind L + HHG x4`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`420`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Eagle + 3 Fly`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Wind L + AC + HHG x3`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`465`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`4 Fly`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Wind L`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`340`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`2 Fly + Winged Serpent`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Wind L`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`289`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`3 Winged Serpents`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Wind L`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`357`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "merry-hills"
    }}>{`Merry Hills`}</h3>
    <p>{`Entreat the money items from the Dramatist in the upper left hand house and grab the Lychee L. Entreat Poetry of the Soul from the Poet under the bridge.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sell-4"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`All money items`}</li>
      </ul>
    </Menu>
    <p>{`Go fight Assassins.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "foreign-assassins"
      }}>{`Foreign Assassins`}</h4>
      <p>{`Format is BG | no BG`}</p>
      <h5 {...{
        "id": "turn-1-2"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: Pom/Apple Partitio`}</li>
        <li parentName="ul">{`Osvald: Springy Boots Partitio`}</li>
        <li parentName="ul">{`Throne: AC x2 Assassin 1`}</li>
        <li parentName="ul">{`Partitio: HHM`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-2"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: HHB x4`}</li>
        <li parentName="ul">{`Agnea: Defend`}</li>
        <li parentName="ul">{`Throne: `}{`[LP]`}{` AC Assassin 4, AC Assassin 2 | AC Assassin 4`}</li>
        <li parentName="ul">{`Osvald: Crit Scope Assassin 1`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-1"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: BG x4 | Stimulate x3 Throne`}</li>
        <li parentName="ul">{`Throne: (Nothing) | AC Assassin 2`}</li>
        <li parentName="ul">{`Partitio: `}{`[LP]`}{` HHB x4`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "money-route"
    }}>{`Money Route`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Money`}</th>
          <th parentName="tr" {...{
            "align": "right"
          }}>{`7260`}</th>
          <th parentName="tr" {...{
            "align": "right"
          }}>{`9000`}</th>
          <th parentName="tr" {...{
            "align": "right"
          }}>{`15000`}</th>
          <th parentName="tr" {...{
            "align": "right"
          }}>{`24000`}</th>
          <th parentName="tr" {...{
            "align": "right"
          }}>{`30000`}</th>
          <th parentName="tr" {...{
            "align": "right"
          }}>{`37000`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Leaves`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Pearl`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`YES`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`YES`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`YES`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`20000`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Warrior's Sword`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`YES`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`YES`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`YES`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`YES`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`YES`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`YES`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`5500`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Marksman's Bow`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`YES`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`YES`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`YES`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`YES`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`YES`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`YES`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`6000`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Silver Monocle`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`YES`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`YES`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`YES`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`4500`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Jewel/Moonshell`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`YES`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`3600`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Strong Axe`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`YES`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`YES`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`2750`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Sai Chest`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`YES`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`YES`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`6200`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Total`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`43317`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`43157`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`42957`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`45407`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`45207`}</td>
          <td parentName="tr" {...{
            "align": "right"
          }}>{`44957`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "tropuhopu"
    }}>{`Tropu'hopu`}</h3>
    <p>{`Steal `}<strong parentName="p">{`Lychee L`}</strong>{` if Throne doesn't have LP.`}<br parentName="p"></br>{`
`}{`Allure `}<strong parentName="p">{`Young Man`}</strong>{`.`}</p>
    <h3 {...{
      "id": "sai"
    }}>{`Sai`}</h3>
    <p>{`Steal Lychee S from boy near the statue.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Lychee S + Lychee L Throne`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-1"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: +Ember`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-2"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Partitio: +`}{`[4]`}{`Boost Start`}</li>
      </ul>
    </Menu>
    <p>{`Kill Dragonridge battle with HHG x2`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "veronica-60000hp-6s-daggeraxefireiceshadow"
      }}>{`Veronica 60000HP 6S (Dagger,Axe,Fire,Ice,Shadow)`}</h4>
      <h5 {...{
        "id": "turn-1-3"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: Attack x2`}</li>
        <li parentName="ul">{`Osvald: Crit Scope`}</li>
        <li parentName="ul">{`Partitio: Ember`}</li>
        <li parentName="ul">{`Throne: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-3"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: `}{`[LP]`}{`Attack x3 + Armor Corrosive`}</li>
        <li parentName="ul">{`Agnea: Summon`}</li>
        <li parentName="ul">{`Osvald: Pom L / Red Apple Partitio if no Latent`}</li>
        <li parentName="ul">{`Partitio: Collect x4`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-2"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: Dagger`}</li>
        <li parentName="ul">{`Partitio: HHB x4`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "merry-hills-1"
    }}>{`Merry Hills`}</h3>
    <p>{`Hired Men: HHB x3`}</p>
    <p>{`If no Lychee L, steal from girl. Lychee L Throne`}<br parentName="p"></br>{`
`}{`If no Poms, Steal one from the baker. `}</p>
    <p>{`Pick `}<strong parentName="p">{`$24000`}</strong>{`.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "dolcinaea-58000hp-6s-daggerspearbowthundershadow"
      }}>{`Dolcinaea 58000HP 6S (Dagger,Spear,Bow,Thunder,Shadow)`}</h4>
      <h5 {...{
        "id": "turn-1-4"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: Attack x2`}</li>
        <li parentName="ul">{`Osvald: Crit Scope`}</li>
        <li parentName="ul">{`Partitio: Spear`}</li>
        <li parentName="ul">{`Throne: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-4"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: `}{`[LP]`}{`Attack x3 + Armor Corrosive`}</li>
        <li parentName="ul">{`Agnea: Summon`}</li>
        <li parentName="ul">{`Partitio: HHB x4`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "dolcinaea-the-star-90000hp-8s-sworddaggeraxefirewind"
      }}>{`Dolcinaea the Star 90000HP 8s (Sword,Dagger,Axe,Fire,Wind)`}</h4>
      <h5 {...{
        "id": "turn-1-5"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: Attack x2`}</li>
        <li parentName="ul">{`Osvald: Crit Scope`}</li>
        <li parentName="ul">{`Partitio: HHM x3`}</li>
        <li parentName="ul">{`Throne: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-5"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Throne: `}{`[LP]`}{`Attack x3 + Armor Corrosive`}</li>
        <li parentName="ul">{`Agnea: Summon`}</li>
        <li parentName="ul">{`Osvald: Pom L / Red Apple Partitio / Defend`}</li>
        <li parentName="ul">{`Partitio: `}{`[LP if needed]`}{` HHB x4`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Osvald: Pom Partitio if needed`}</li>
        <li parentName="ul">{`Partitio: HHB x4`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "addendum"
    }}>{`Addendum`}</h3>
    <h4 {...{
      "id": "faster-duorduor-not-recommended"
    }}>{`Faster Duorduor (not recommended)`}</h4>
    <p>{`You need Gus before Duorduor T2, both characters to be healthy, and for Duorduor to hit Gus T1.`}<br parentName="p"></br>{`
`}{`The fight saves ~2 seconds. It's also risky if Agnea isn't the one healed on T8, her dying to Writhe is a range.`}</p>
    <Battle mdxType="Battle">
      <h5 {...{
        "id": "turn-1-6"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: Attack`}</li>
        <li parentName="ul">{`Gus: Chop Wood`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-6"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: Lion Dance`}</li>
        <li parentName="ul">{`Gus: Chop Wood`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-4"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Gus: Chop Wood x4`}</li>
        <li parentName="ul">{`Agnea: Ruinous Kick x4`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4-1"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: Plum Gus`}</li>
        <li parentName="ul">{`Gus: Chop Wood`}</li>
      </ul>
      <h5 {...{
        "id": "turn-5-1"
      }}>{`Turn 5`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: Attack`}</li>
        <li parentName="ul">{`Gus: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-6-1"
      }}>{`Turn 6`}</h5>
      <ul>
        <li parentName="ul">{`Gus: Chop Wood`}</li>
        <li parentName="ul">{`Agnea: Lion Dance`}</li>
      </ul>
      <h5 {...{
        "id": "turn-7-1"
      }}>{`Turn 7`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: Ruinous Kick x4`}</li>
        <li parentName="ul">{`Gus: Shadow S`}</li>
      </ul>
      <h5 {...{
        "id": "turn-8-1"
      }}>{`Turn 8`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: Wind S`}</li>
        <li parentName="ul">{`Gus: Grape`}</li>
      </ul>
      <h5 {...{
        "id": "turn-9-1"
      }}>{`Turn 9`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: Attack`}</li>
        <li parentName="ul">{`Gus: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-10-1"
      }}>{`Turn 10`}</h5>
      <ul>
        <li parentName="ul">{`Gus: Attack x4`}</li>
        <li parentName="ul">{`Agnea: Lion Dance`}</li>
      </ul>
      <h5 {...{
        "id": "turn-11-1"
      }}>{`Turn 11`}</h5>
      <ul>
        <li parentName="ul">{`Agnea: Ruinous Kick x4`}</li>
        <li parentName="ul">{`Gus: Attack x3`}</li>
      </ul>
    </Battle>
    <h4 {...{
      "id": "standard-1-puff-route"
    }}>{`Standard /1 Puff Route`}</h4>
    <h5 {...{
      "id": "hhg-merry-hills-and-dragonridge"
    }}>{`HHG Merry Hills and Dragonridge`}</h5>
    <ul>
      <li parentName="ul">{`Vivid Jewel`}</li>
      <li parentName="ul">{`Silver-Rimmed Monocle`}</li>
      <li parentName="ul">{`Warrior's Sword`}</li>
      <li parentName="ul">{`Marksman's Bow`}</li>
      <li parentName="ul">{`Sell Refreshing Jam`}</li>
      <li parentName="ul"><strong parentName="li">{`Sell in Sai`}</strong></li>
      <li parentName="ul">{`Tally: +168`}</li>
    </ul>
    <h5 {...{
      "id": "hhg-dragonridge"
    }}>{`HHG Dragonridge`}</h5>
    <ul>
      <li parentName="ul">{`Silver-Rimmed Monocle`}</li>
      <li parentName="ul">{`Warrior's Sword`}</li>
      <li parentName="ul">{`Marksman's Bow`}</li>
      <li parentName="ul">{`Tally: +1543`}</li>
    </ul>
    <h5 {...{
      "id": "no-hhg"
    }}>{`No HHG`}</h5>
    <ul>
      <li parentName="ul">{`Silver-Rimmed Monocle`}</li>
      <li parentName="ul">{`Warrior's Sword`}</li>
      <li parentName="ul">{`Tally: +1556`}</li>
    </ul>
    <h4 {...{
      "id": "1-cait-route--queen-puff-route"
    }}>{`1 Cait Route / Queen Puff route`}</h4>
    <h5 {...{
      "id": "hhg--hhb"
    }}>{`HHG + HHB`}</h5>
    <ul>
      <li parentName="ul">{`Pearl Quest (15000 + 5000)`}</li>
      <li parentName="ul">{`Silver-Rimmed Monocle (4500)`}</li>
      <li parentName="ul">{`Marksman's Bow (6000)`}</li>
      <li parentName="ul">{`Warrior's Sword (5500)`}</li>
      <li parentName="ul"><strong parentName="li">{`Don't`}</strong>{` Sell Refreshing Jam`}</li>
      <li parentName="ul"><strong parentName="li">{`Sell in Sai`}</strong>{`: -1074`}</li>
      <li parentName="ul">{`Tally: +1196`}</li>
    </ul>
    <h5 {...{
      "id": "hhb-or-hhg-x2"
    }}>{`HHB OR HHG x2`}</h5>
    <ul>
      <li parentName="ul">{`Silver-Rimmed Monocle (4500)`}</li>
      <li parentName="ul">{`Marksman's Bow (6000)`}</li>
      <li parentName="ul">{`Warrior's Sword (5500)`}</li>
      <li parentName="ul">{`Sell Refreshing Jam (1875)`}</li>
      <li parentName="ul">{`Veronica Collect (10000)`}</li>
      <li parentName="ul">{`Tally: +71 / +1071`}</li>
    </ul>
    <h5 {...{
      "id": "hhg"
    }}>{`HHG`}</h5>
    <ul>
      <li parentName="ul">{`Silver-Rimmed Monocle (4500)`}</li>
      <li parentName="ul">{`Marksman's Bow (6000)`}</li>
      <li parentName="ul">{`Warrior's Sword (5500)`}</li>
      <li parentName="ul">{`Moonshell Accessories (3600)`}</li>
      <li parentName="ul">{`Sell Refreshing Jam (1875)`}</li>
      <li parentName="ul">{`Tally: +1671`}</li>
    </ul>
    <h5 {...{
      "id": "none-multi-caitpuff-so-adjust-as-needed"
    }}>{`None (Multi Cait/Puff, so adjust as needed)`}</h5>
    <ul>
      <li parentName="ul">{`Silver-Rimmed Monocle (4500)`}</li>
      <li parentName="ul">{`Marksman's Bow (6000)`}</li>
      <li parentName="ul">{`Warrior's Sword (5500)`}</li>
      <li parentName="ul">{`Sell Refreshing Jam (1875)`}</li>
      <li parentName="ul">{`Tally: +490`}</li>
    </ul>
    <h3 {...{
      "id": "older-cait--puff-notes"
    }}>{`Older Cait + Puff notes`}</h3>
    <h4 {...{
      "id": "1-cait-or-2-puff"
    }}>{`1 Cait or 2 Puff`}</h4>
    <p>{`Will need to kill 2 Merry Hills battles (preferably day) and up to 2 Sai battles. Might still be short afterwards, depending on what Merry Hills battles you got. Worst battles leave you short about 100. `}</p>
    <h4 {...{
      "id": "1-cultured-cait"
    }}>{`1 Cultured Cait`}</h4>
    <p>{`Take 1 day 1 night battle. Might need Sai battles.`}</p>
    <h4 {...{
      "id": "1-queen-puff"
    }}>{`1 Queen Puff`}</h4>
    <p>{`Post Merry Hills battle, want Osvald to have >= `}<strong parentName="p">{`1522JP`}</strong>{` (Assuming T1 kill bonus). If short, go tag Sai early and kill stuff on the way. Then teach Osvald Extra Experience. Will want to take day Merry Hills battles. Will likely need both Sai battes for EXP as well, depends on Merry Hills groups. With day Merry Hills and night Sai should have enough.`}</p>
    <h4 {...{
      "id": "cait--puff"
    }}>{`Cait + Puff`}</h4>
    <p>{`Can take night Merry Hills, but if worst battle will need 2 Sai battles.`}</p>
    <h4 {...{
      "id": "1-queen-puff--1-puff"
    }}>{`1 Queen Puff + 1 Puff`}</h4>
    <p>{`Extra Experience Assassins, and possibly 1 Sai battle covers it. Can opt for night Merry Hills, but if worst battle will need 2 Sai battles.`}</p>
    <h4 {...{
      "id": "king-puff"
    }}>{`King Puff`}</h4>
    <p>{`Extra Experience, and 1/2 Sai battle should be enough.`}</p>
    <p>{`Anything not mentioned doesn't need anything extra.`}<br parentName="p"></br>{`
`}{`No Caits/Puffs does BG`}</p>
    <h3 {...{
      "id": "changelog"
    }}>{`Changelog`}</h3>
    <h4 {...{
      "id": "4324"
    }}>{`4/3/24`}</h4>
    <ul>
      <li parentName="ul">{`First "complete" upload`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      